import React from "react";
import { Heading } from "@usap/uicomponents";
// 24px
export default function Heading2({ title = "", ...props }) {
  return (
    <Heading
      responsive={false}
      level={2}
      margin="0px"
      color="dark-2"
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
